
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoiZHBpdGVjaCIsImEiOiJjbGc2djh6YTEwMDZnM2NtYjFxNmJwbmttIn0.jFNOl43jnk5jVhOIHf0Fyg"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
